import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrLoadingBricks from "UI/FnrLoadingBricks";
import { colors } from "UI/colors";

ProgressBar.propTypes = {
  percent: PropTypes.number,
};

export default function ProgressBar({ percent }) {
  const [isProcessing, setShowProcessing] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (percent > 99) {
      setTimeout(() => {
        if (isMounted) setShowProcessing(true);
      }, 500);
    }
  }, [percent, isMounted]);

  return (
    <Wrapper>
      <Bar
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          width: `${percent}%`,
          transition: { opacity: { delay: 0.2 } },
        }}
      >
        <BarContent>
          {isProcessing ? "Processing..." : "Uploading..."}
          <LoadingWrapper>
            <FnrLoadingBricks show={isProcessing} size={42} />
          </LoadingWrapper>
        </BarContent>
      </Bar>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex: 1;
  margin: 2px;
`;

const Bar = styled(motion.div)`
  background-color: white;
  height: 46px;
  margin: 2px;
  border-radius: 8px;
  color: ${colors.fnDkBlueGray};
  font-size: 18px;
  display: flex;
  align-items: center;
  max-width: 99%;
`;

const BarContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 10px;
`;

const LoadingWrapper = styled.div`
  margin-top: 6px;
  margin-right: 2px;
`;
